export default __webpack_public_path__ + "static/media/palette.2d50a992.svg";